import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../service';
import { ClienteModel } from './../model';
import { constants } from './../app-constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  clienteModel: ClienteModel;
  isLoggedIn = false;
  logo: string;
  cliente: any;

  constructor(private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.clienteModel = JSON.parse(localStorage.getItem(constants.clienteKey));
    this.isLoggedIn = this.clienteModel !== null ? true : false;
    this.cliente = JSON.parse(localStorage.getItem(constants.clienteKey));

    if (this.cliente != null && this.cliente.logo != null) {
      this.logo = this.cliente.logo;
    } else {
      this.logo = '';
    }
  }

  public doLogout() {
    this.authenticationService.logout();
  }
}
